/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { arrayOf, entity, enumeration, subentity } from '@gh/core-data';
import {
  ChecklistDetailsDto,
  ChecklistDto,
  ChecklistElementType,
  ChecklistSectionDto,
} from './mobile-checklists.model';

export const MobChecklistMapper = entity<ChecklistDto>({});
export const MobChecklistDetailMapper = entity<ChecklistDetailsDto>({
      checklistElements: arrayOf(subentity<ChecklistSectionDto>({
        elementType: enumeration(ChecklistElementType),
      })),
  });
